import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import fetch from './utils/fetch'
import global from './utils/global'
import mvel from './utils/mvel'
import store from '@/store'
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'
import App from './App'
import router from './router'

Vue.use(Element)
Vue.use(global)
Vue.use(mvel, mvel)
Vue.use(VXEUtils, XEUtils)

Vue.prototype.$http = fetch
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js